





















import Vue, { PropType } from 'vue';
import ChipsElement from '@/components/chips/ChipsElement.vue';
import {
  TSelectedFilterValue,
  TSelectedFilterValues,
} from '@/components/table/types';

export default Vue.extend({
  name: 'TableFilterValues',
  components: { ChipsElement },

  props: {
    values: {
      type: Array as PropType<TSelectedFilterValues>,
      required: false,
      default: () => [],
    },
    usePrefix: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    showPrefix(item: TSelectedFilterValue): boolean {
      return !!(this.usePrefix && item?.prefix);
    },
    remove(item: TSelectedFilterValue) {
      this.$emit('delete', item);
    },
  },
});
